import React from "react";
import PropTypes from 'prop-types';

import { Separator } from "../Headers/Separator";
import { Highlights } from "./Highlights";
// import FotoCV from  '../../assets/fotos/DSC_0607.JPG'
// import CV from '../../assets/RaúlLucioPorto-CVU-2023-website.pdf'

import '../../styles/home.css'

export const Home = (props) =>{
    if ( !props.profile )
    {
        return null;
    }
    return(
        <section id="Home" className="section">
            <Separator name='Home'></Separator>
            <div className="container">
                <div className="row">
                    <div className="col-md-4 d-flex align-items-center justify-content-center flex-column ">
                        <div className="picture-home d-flex align-items-center justify-content-center flex-column">
                                <img className="foto-cv" src={props.profile.image_url} alt={props.profile.name} />
                        </div>
                        <a href={props.profile.pdf_url} target='_blank' rel="noreferrer" className="btn btn-dark cv-btn">Curriculum</a>

                    </div>
                    <div className="col-md-8  ">
                        <div className="row">                        
                                <div className="col-md-12 ">
                                    <div className="semblaza">
                                        <h4>{props.profile.name}</h4>
                                        <p className="text-justify">{props.profile.main_info}</p>
                                    </div>
                                </div>
                            </div>
                        <div className="row">
                            <div className="col-md-12 ">
                                <Highlights icon='bi-search'  color='color-blue' text='Sistema Nacional de Investigadores Nivel II'></Highlights>
                                <Highlights icon='bi-battery-charging' color='color-ligth-blue' text='Miembro del Consejo Técnico Académico de la RED CONACyT de Almacenamiento de Energía'></Highlights>
                                <Highlights icon='bi-clipboard2-pulse' color='color-green'   text='Jefe del Departamento de los Laboratorios de Ingeniería Biomédica (FIME UANL)'></Highlights>

                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </section>
    )
}

Home.propTypes = {
    profile: PropTypes.shape({
        name: PropTypes.string.isRequired,
        image_url: PropTypes.string.isRequired,
        pdf_url: PropTypes.string.isRequired,
        main_info: PropTypes.string,
    }),
};